
export const NFT_SALE_ADDRESS = '0x321c770653b07a042dbe9c1426f5be8938755c19'
export const NFT_CEREBRUM_ADDRESS = '0x1c9356a6599cd8a5cc44eb7c053e6d3b5b52493f'
export const BAHANUT_RPC_URL = 'https://rpc1.bahamut.io'

export const SALE_ADDRESS_OLD = "0xd423e542efc2d3908d607afe1006d2dddb85bc63";


// export const FTN_SCANNER = "https://www.ftnscan.com/token/";
// export const CHAIN = "5165";